import type { ApplicationSettingsTabId } from '../store/application-settings-tab-id';
import { useLayoutStore } from '../store/layoutStore';
import { setApplicationSettingsSubTabOnActiveTab } from './setMainContentSettingsSubTab';

const SETTINGS_TAB_INPUT = {
  id: 'settings',
  title: 'Settings',
  type: 'settings',
} as const;

export function navigateToApplicationSettingsSubTab(
  subTab: ApplicationSettingsTabId,
): void {
  useLayoutStore.getState().openOrFocusMainContentTab(SETTINGS_TAB_INPUT);
  setApplicationSettingsSubTabOnActiveTab(subTab);
}
